import styled from 'styled-components'

const Layout = styled.div`
  background-color: #fff;
  margin: 30px 165px 0;

  @media (max-width: 1200px) {
    margin: 30px 80px 0;
  }

  @media (max-width: 768px) {
    margin: 30px 30px 0;
  }
`

export default Layout
